import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full px-8" }
const _hoisted_2 = { class: "flex flex-col justify-center mt-10 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white font-semibold text-4xl mt-8" }, " Ödemeniz başarıyla alındı! ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-medium text-base" }, "Detaylı raporun indirme linki en kısa süre içinde e-posta adresinize iletilecektir.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check_circle_outlined = _resolveComponent("check-circle-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_check_circle_outlined, {
        style: { color: '#52c41a' },
        class: "text-9xl"
      }),
      _hoisted_3,
      _hoisted_4
    ])
  ]))
}